export default __webpack_public_path__ + "static/media/A0006.0386d9e0.png";